import { ANALYTICS_HEAP_IDS, formatHeapId } from '@/common/constants';
import classNames from 'classnames';
import React from 'react';
import { NavbarExpansionItemProp } from '../../../types';
import styles from './Expansion.module.scss';

export interface ExpansionProps {
  items: NavbarExpansionItemProp[];
  isExpanded: boolean;
  /** Title of the parent navigation item that controls this expansion - used for aria-labelledby */
  parentTitle?: string;
}

export const Expansion: React.FC<ExpansionProps> = ({ items, isExpanded, parentTitle }) => {
  const classes = classNames(styles.expansion, isExpanded ? styles.expansion_show : '');

  return (
    <div
      className={classes}
      role="menu"
      aria-labelledby={parentTitle}
      aria-label="Navigation submenu"
      aria-hidden={!isExpanded}
    >
      {items.map((item, index) => (
        <div key={item.sectionName} className={styles.section}>
          <span className={styles.section_name}>{item.sectionName}</span>
          <ul className={styles.section_links} role="group" aria-label={item.sectionName}>
            {item.expansionLinks.map((link, idx) => (
              <li key={link.label + index} role="menuitem">
                <a
                  href={link.link}
                  style={{ animationDelay: `${idx * 0.08}s` }}
                  tabIndex={isExpanded ? 0 : -1}
                  data-heap-id={formatHeapId([
                    ANALYTICS_HEAP_IDS.DESKTOP,
                    ANALYTICS_HEAP_IDS.NAVBAR_EXPANSION,
                    item.sectionName,
                    link.label,
                  ])}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
